export enum PubSubActions {
  /** Reload the Flags Track */
  REFETCH_REGION_FLAGS = "GENOME-VIEWER/REFETCH_REGION_FLAGS",
  /** WebSocket "file" events */
  FILE = "WEBSOCKET/FILE",
  /** File editing events */
  FILE_EDIT = "FILE/EDIT",
}
